module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-breadcrumbs"
  }, [_c('ul', [_c('li', {
    staticClass: "app-breadcrumbs__item"
  }, [_c('button', {
    class: ['app-breadcrumbs__context-button', _vm.showBreadcrumbs ? 'has-breadcrumbs' : '']
  }, [_c('app-icon-button', {
    class: ['app-switcher__button--svg', 'app-breadcrumbs__context-button__icon'],
    attrs: {
      "prototype": {
        icon: require('../assets/icons/icon-chevron-down.svg')
      }
    }
  }), _vm._v(" "), _c('app-icon-button', {
    attrs: {
      "prototype": _vm.currentApp
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "app-breadcrumbs__context-button__label"
  }, [_vm._v(_vm._s(_vm.currentApp.name))])], 1), _vm._v(" "), (_vm.showContextSwitcherButton && _vm.showBreadcrumbs) ? _c('button', {
    class: ['app-breadcrumbs__context-switcher-button', _vm.showAppSwitcher ? 'active' : null],
    on: {
      "click": function () { return _vm.tools.actions.toggleContextSwitcher(); }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#010202",
      "d": "M21.248 10.171h-2.29v-2.29a.75.75 0 0 0-.75-.75h-2.29V4.84a.75.75 0 0 0-.75-.75H2.752a.75.75 0 0 0-.75.75v8.238c0 .414.336.75.75.75h2.09c.071 0 .135-.022.2-.04v2.33c0 .414.336.75.75.75h2.09c.071 0 .135-.022.2-.04v2.33c0 .414.336.75.75.75h12.417a.75.75 0 0 0 .75-.75V10.92a.75.75 0 0 0-.751-.749zM5.042 7.881v4.489c-.065-.018-.129-.04-.2-.04h-1.34V5.59h10.917v1.54H5.792a.751.751 0 0 0-.75.751zm3.04 3.04v4.489c-.065-.018-.129-.04-.2-.04h-1.34V8.631h10.917v1.54H8.832a.75.75 0 0 0-.75.75zm12.416 7.488H9.582v-6.738h10.917v6.738z"
    }
  })])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.data), function(breadcrumb, index) {
    return (_vm.data.length && !_vm.showAppSwitcher && _vm.showBreadcrumbs) ? _c('li', {
      staticClass: "app-breadcrumbs__item"
    }, [(!Array.isArray(breadcrumb)) ? _c('button', {
      staticClass: "app-breadcrumbs__button",
      attrs: {
        "title": breadcrumb.title
      },
      on: {
        "click": function () { return _vm.updateBreadcrumbs(breadcrumb.i); }
      }
    }, [_vm._v(_vm._s(_vm.concat(breadcrumb.title)))]) : _vm._e(), _vm._v(" "), (Array.isArray(breadcrumb)) ? [_c('button', {
      staticClass: "app-breadcrumbs__dropdown_toggle",
      on: {
        "click": _vm.toggleDropdown
      }
    }, [_c('img', {
      staticClass: "app-breadcrumbs__dots",
      attrs: {
        "src": require('../assets/icons/icon-dots.svg'),
        "alt": ""
      }
    })]), _vm._v(" "), _c('ul', {
      ref: "dropdown",
      refInFor: true,
      class: ['app-breadcrumbs__dropdown', _vm.dropdownVisible ? 'active' : null]
    }, _vm._l((breadcrumb), function(subMenuBreadcrumb) {
      return _c('li', {
        staticClass: "app-breadcrumbs__dropdown__item"
      }, [_c('button', {
        staticClass: "app-breadcrumbs__dropdown__item__button",
        on: {
          "click": function () { return _vm.updateBreadcrumbs(subMenuBreadcrumb.i); }
        }
      }, [_vm._v("\n                            " + _vm._s(subMenuBreadcrumb.title) + "\n                        ")])])
    }))] : _vm._e(), _vm._v(" "), _c('svg', {
      staticClass: "app-breadcrumbs__arrow",
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 15 22",
        "enable-background": "new 0 0 15 22",
        "xml:space": "preserve"
      }
    }, [_c('polygon', {
      attrs: {
        "points": "1.411,21.907 0.528,21.498 5.396,11 0.528,0.502 1.411,0.093 6.469,11 "
      }
    })])], 2) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c7571a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumbs.vue
// module id = 424
// module chunks = 1